import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import {
  HttpOptions,
  HttpOptionsWithBlobResponse,
  HttpOptionsWithJsonEvents,
  HttpOptionsWithText,
} from './http-options';
import { CacheService } from './cache-service';

@Injectable()
export class ApiService {
  constructor(private readonly httpClient: HttpClient, private readonly cacheService: CacheService) {}

  post<Response, T = Response>(url: string, body: T | string, options?: HttpOptions): Observable<Response> {
    return  this.httpClient.post<Response>(url, body, options);
  }

  
  post2(url: string, body: any, options?: HttpOptions) {
    return this.httpClient.post(url, body, options);
  }

  // postAny<T>(url: string, body: any, options?: HttpOptions): Observable<T> {
  //   return this.httpClient.post<T>(url, body, options);
  // }

  // postWithBinaryResponse(
  //   url: string,
  //   body: any | null,
  //   options: HttpOptionsWithBlobResponse,
  // ): Observable<HttpResponse<Blob>> {
  //   return this.httpClient.post(url, body, options);
  // }

  // postWithJsonEvents(url: string, body: any | null, options: HttpOptionsWithJsonEvents): Observable<HttpEvent<any>> {
  //   return this.httpClient.post(url, body, options);
  // }

  get<T>(url: string, options?: HttpOptions): Observable<T> {
    return this.httpClient.get<T>(url, options);
  }

  // getWithTextResponse(url: string, options?: HttpOptionsWithText): Observable<string> {
  //   return this.httpClient.get(url, options);
  // }

  // getWithBinaryResponse(url: string, options: HttpOptionsWithBlobResponse): Observable<HttpResponse<Blob>> {
  //   return this.httpClient.get(url, options);
  // }

  // getCached<T>(url: string, options?: HttpOptions): Observable<T> {
  //   return of(true).pipe(switchMap(() => this.cacheService.get(url, this.get<T>(url, options))));
  // }

  // put<T>(url: string, body: T, options?: HttpOptions): Observable<T> {
  //   return this.httpClient.put<T>(url, body, options);
  // }

  // patch<T>(url: string, body: T, options?: HttpOptions): Observable<T> {
  //   return this.httpClient.patch<T>(url, body, options);
  // }

  // delete<T>(url: string, options?: HttpOptions): Observable<T> {
  //   return this.httpClient.delete<T>(url, options);
  // }

  sendBeacon(url: string, data: any) {
    navigator.sendBeacon(url, JSON.stringify(data));
  }

  getFileWithBinaryResponse(url: string, fileName: string, type: string, userInfo: any) {
    const xhr = new XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.setRequestHeader('Content-Type', `application/${type}`);
    xhr.setRequestHeader('Authorization', `${userInfo.token_type} ${userInfo.access_token}`);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (this.status === 200) {
        const blob = this.response;
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(blobUrl);
      }
    };
    xhr.send();
  }
}
